import Scene = Phaser.Scene;
import {AbstractNavPanel} from "@/scenes.ui/abstract-nav-panel";
import {ClanTheme} from "@/scenes.ui.clan/clan-theme";

export default class ClanThemeNavPanel extends AbstractNavPanel {

    private clickCallback!: (theme: string) => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, themes: string[],
                clickCallback: (theme: string) => unknown) {
        super(scene, canvas, x, y, themes, 1);

        this.x = x;
        this.y = y;
        this.clickCallback = clickCallback;
    }

    protected makePanel(x: number, element: any): any {
        let self = this;
        let theme = <string>element;
        let clanTheme = new ClanTheme(this.scene!, x, theme, () => {
            self.clickCallback(theme);
        });
        clanTheme.setDepth(1000);

        return clanTheme;
    }

    protected getButtonX(): number {
        return 150;
    }

    protected getButtonY(): number {
        return 0;
    }

    protected calculateCellWidth(creaturesAmount: number): number {
        return 140;
    }



}

